/**
 * The below file contains the action methods for fire master.
 * @author: shivam.sharma2@velsof.com
 * @date : 10-01-2023
 */

import {
  GET_ALL_FIRE_CATEGORY,
  SET_ALL_FIRE_CATEGORY,
} from "redux/constants/FireCategory";

//#region Action methods for fetching fire categories

/**
 * Method for getting the fire categories
 * @param {any} params Fire Data
 * @returns Json Object
 */
export const getAllFireCategory = () => {
  return {
    type: GET_ALL_FIRE_CATEGORY,
  };
};

/**
 * Method for setting the fire categories
 * @param {any} params Fire Data
 * @returns Json Object
 */
export const setAllFireCategory = (data) => {
  return {
    type: SET_ALL_FIRE_CATEGORY,
    payload: data,
  };
};

//#endregion